export class DriverService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  async getAllDrivers() {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/gestionnaire/chauffeurs`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des chauffeurs:", error);
      throw error;
    }
  }

  async loadDocumentFile(
    driverId: number,
    entrepriseId: number,
    documentId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/chauffeur/${driverId}/document/${documentId}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.blob();
    } catch (error) {
      console.error("Erreur lors de la récupération du document:", error);
      throw error;
    }
  }

  async addDocumentDriver(
    driverId: number,
    entrepriseId: number,
    documentFormData: FormData,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/chauffeur/${driverId}/document`,
        {
          method: "POST",
          headers: {
          },
          body: documentFormData,
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du document au chauffeur':", error);
      throw error;
    }
  }

  async deleteDocumentDriver(
    driverId: number,
    entrepriseId: number,
    documentId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/chauffeur/${driverId}/document/${documentId}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la suppression du document du chauffeur':",
        error,
      );
      throw error;
    }
  }

  async updateDriver(driverId: number, entrepriseId: number, driver: any) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/chauffeur/${driverId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(driver),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du chauffeur:", error);
      throw error;
    }
  }

  async deleteDriver(driverId: number, entrepriseId: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/chauffeur/${driverId}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du chauffeur':", error);
      throw error;
    }
  }
}
